import React from 'react'

import DocPageItem from "./item/page"
import ReorderList from "../../../../../core/gd-ui/sortable-list-4/reorder-list"
import VScroll from "../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import DocumentPages from "../../../../../core/model2/doc/pages/pages"
import DocumentPage from "../../../../../core/model2/doc/pages/page"

type Props = {
    pages           : DocumentPages
    currentPageId   : ID

    disabled        : boolean

    onAdd           : {(page: DocumentPage):void}
    onRemove        : {(pageId: ID):void}
    onClick         : {(page: DocumentPage):void}
}

export default class DocumentViewPages extends React.Component<Props> {

    update = () => {
        this.forceUpdate()
    }

    onDragPageItemsEnd = (pageItems: DocumentPage[]) => {
        this.props.pages.reorder(_.map(pageItems, item=>item.id))
    }

    onNewPage = (e: React.MouseEvent) => {
        e.stopPropagation()

        const page = this.props.pages.addPage({})

        gd.bus.triggerEvent('doc:pages-changed')

        if (this.props.onAdd) this.props.onAdd(page)
    }

    onClick = (page: DocumentPage) => {
        if (this.props.onClick) this.props.onClick(page)
    }

    onDelete = (page: DocumentPage) => {
        gd.modals.confirm.genericText('Delete page','Are you sure you want to delete this page?', () => {
            gd.modal.hide()
            this.props.onRemove(page.id)
            // this.props.pages.removePage(page.id)
            // gd.bus.triggerEvent('doc:pages-changed')
        }, {
            yesBtnLabel: 'Yes, delete'
        });
    }

    render() {
        if (this.props.pages.length <= 1) return false

        const menuItems: any = []
        _.map(this.props.pages.getItems(), page=>{
            menuItems.push({
                item        : page,
                component   : <DocPageItem data     = {page}
                                           selected = {page.id === this.props.currentPageId}
                                           disabled = {this.props.disabled}
                                           onClick  = {this.onClick}
                                           onDelete = {this.onDelete}/>
            })
        })

        return (
            <div className="pages ui5-menu open">
                {/*<div className="pages-header ui5-header s11 no-accent">
                    <div className="left">
                        <div className="name">Pages</div>
                    </div>
                </div>*/}
                <VScroll className="pages-scroll">
                    <ReorderList items          = {menuItems}
                                 keyFunction    = {item=>item.id}
                                 onReorder      = {this.onDragPageItemsEnd}/>

                    {!this.props.disabled &&
                        <div className="add" onClick={this.onNewPage}>
                            <div className="icon i5-plus"/>
                            New page
                        </div>}
                </VScroll>
            </div>
        )
    }
}